






















































































































































































































import Vue from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Footer from '@/vue-components/nav/Footer.vue';

export default Vue.extend({
  name: 'Home',
  // metaInfo: {
  //   title: 'Find your spark',
  //   meta: [
  //     { name: 'description', content: 'Create an account or log into Sparkello. Be inspired to fulfil your dreams. A simple, fun &amp; creative way to create your dream board and connect with others who share your passions.' }
  //   ],
  // },
  components: {
    Footer,
  },
  created() {
    AOS.init();
  },
  computed: {
    title(): string {
      return 'Sparkello';
    },
  },
});
